import React, { FC } from 'react'

import { PLAN_V3_CATEGORIES, getPlanCategoryLabel } from '@smarty-nx/code-utils'
import { Typography } from '@smarty-nx/ds'

import { TooltipModal } from '../../../../components/Modals'
import classes from '../../../../components/PlanSectionPhase2/plan-section-phase2.module.scss'
import { CheckIcon } from '../../../../components/shared'
import CheckImage from '../../../../static/images/checkmark.svg'

const classicPlanCategoryLabel = getPlanCategoryLabel(
  PLAN_V3_CATEGORIES.CLASSIC
)

export const VoiceInfoModal: FC = () => {
  return (
    <TooltipModal header={`${classicPlanCategoryLabel}`} ariaHideApp={false}>
      <Typography
        variant="Kollektif/ExtraSmall"
        variantSm="Kollektif/Small"
        className={classes.tooltipHeading}
      >
        Your choice of data, with unlimited calls &amp; texts. That&apos;s
        simple and SMARTY.
      </Typography>
      <Typography
        variant="Kollektif/ExtraSmall"
        variantSm="Kollektif/Small"
        className={classes.tooltipHeading}
      >
        As always, 1 month plans. No contracts, no credit checks and no
        surprises at the end of the month. Cancel or change plans anytime. Pay
        in advance and enjoy the flexibility.
      </Typography>
      <Typography
        variant="Kollektif/ExtraSmall"
        variantSm="Kollektif/Small"
        className={classes.tooltipHeading}
      >
        <strong>
          eSIM available – activate instantly, no plastic SIM needed.
        </strong>
      </Typography>
    </TooltipModal>
  )
}

export const DataOnlyInfoModal: FC = () => {
  return (
    <TooltipModal header="Data Only plans" ariaHideApp={false}>
      <Typography
        variant="Kollektif/ExtraSmall"
        variantSm="Kollektif/Small"
        className={classes.tooltipHeading}
      >
        No calls and texts, just great value data.
      </Typography>
      <ul className={classes.list}>
        <li className={classes.listItem}>
          <CheckIcon src={CheckImage} alt="" />
          <Typography
            variant="Kollektif/ExtraSmall"
            variantSm="Kollektif/Small"
            className={classes.tooltipPara}
          >
            Use data in the UK and roaming EU countries{' '}
          </Typography>
        </li>
        <li className={classes.listItem}>
          <CheckIcon src={CheckImage} alt="" />
          <Typography
            variant="Kollektif/ExtraSmall"
            variantSm="Kollektif/Small"
            className={classes.tooltipPara}
          >
            Unrestricted hotspotting and no speed limits
          </Typography>
        </li>
        <li className={classes.listItem}>
          <CheckIcon src={CheckImage} alt="" />
          <Typography
            variant="Kollektif/ExtraSmall"
            variantSm="Kollektif/Small"
            className={classes.tooltipPara}
          >
            No contract: 1 month plan
          </Typography>
        </li>
      </ul>
      <Typography
        variant="Kollektif/ExtraSmall"
        variantSm="Kollektif/Small"
        className={classes.tooltipHeading}
      >
        <strong>
          eSIM available – quick, easy setup on compatible devices.
        </strong>
      </Typography>
      <Typography
        variant="Kollektif/ExtraSmall"
        variantSm="Kollektif/Small"
        className={classes.tooltipHeading}
      >
        <strong>Note: </strong>
        Data Only plans cannot be switched or upgraded to{' '}
        {classicPlanCategoryLabel} or Money Back plans just yet.
      </Typography>
    </TooltipModal>
  )
}

export const SocialTariffInfoModal: FC = () => {
  return (
    <TooltipModal header="Social Tariff plans" ariaHideApp={false}>
      <Typography
        variant="Kollektif/ExtraSmall"
        variantSm="Kollektif/Small"
        className={classes.tooltipHeading}
      >
        Low-cost unlimited data, calls and texts for eligible customers in
        receipt of income-based employment support, income-based job seekers,
        income support, pension credit or universal credit.
      </Typography>
      <Typography
        variant="Kollektif/ExtraSmall"
        variantSm="Kollektif/Small"
        className={classes.tooltipHeading}
      >
        1 month plans, but keep for as long as you want to (subject to
        eligibility) and no credit checks.
      </Typography>
    </TooltipModal>
  )
}
